<template>
  <div class="bg">
    <headline :params="headLines" />
    <div class="container clueD-container">
      <div class="content">
        <article :class="{center: history_id}">
          <div class="top">
            <div class="title">
              <h4 v-if="detailData">{{detailData.title}}</h4>
              <div class="aux">
                <span class="view">
                  <p @click="toggleView">浏览{{visit_log}}</p>
                  <img @click="toggleView" :class="{up: showView}" src="@assets/img/common/smalldown.svg" alt="">
                  <ul v-show="showView" :class="{'view-container': true, more: visit_log >= 10}">
                    <li v-for="(item,index) in visit_log_list" :key="index" @click="showCard1(item.uid, $event)">
                      <div class="left">{{item.truename}}</div>
                      <div class="right">{{item.raw_add_time}}</div>
                    </li>
                  </ul>
                </span>
                <span class="en" v-if="detailData.has_translate_role">英译中 <div class="tips">该翻译由系统自动生成，仅供参考</div></span>
                <span :class="{up: showVersions}" @click="toggleVersions()">
                  历史版本
                  <p class="history" v-show="showVersions" v-if="history.length > 0">
                    <i class="line" :style="{height: `${(history.length-1) * 50}px`}"></i>
                    <i class="head">
                      <i class="topic">历史版本时间</i>
                      <i class="user">操作人</i>
                    </i>
                    <i class="i" v-for="(h, j) in history" :key="j" @click.stop="chooseVersion(h)">
                      <i :class="{dot: true, g:h.history_id == history_id}"></i>
                      <i class="title">{{h.raw_add_time}}</i>
                      <i class="time">{{h.user_name}}</i>
                    </i>
                  </p>
                </span>
              </div>
            </div>
            <div class="date">
              <label v-if="detailData.username" :class="{'card': detailData.uid != 0}" @click="showCard(detailData.uid, $event)">
                {{detailData.username}}
              </label>
              <span v-if="detailData">{{detailData.release_time}}</span>
            </div>
            <div class="sub">
              <!-- <label>类型：</label>
              <span>{{detailData.category_name || '无'}}</span> -->
              <label>信源：</label>
              <span>{{(detailData.source_info && detailData.source_info.ptitle) || '无'}}</span>
              <label>频道：</label>
              <span>{{(detailData.source_info && detailData.source_info.stitle)}}</span>
              <label>上传来源：</label>
              <span>{{detailData.from_platform || '无'}}</span>
            </div>
          </div>
          <div class="line" v-if="!detailData.warning_content"></div>
          <div class="warning" v-if="detailData.warning_content">
            <div class="box">
              <img src="@assets/img/common/warn.svg" alt="warn">
              <div class="info">
                <div class="about">
                  <span class="name">{{detailData.warning_username}}</span>
                  <span>{{detailData.warning_addtime}}</span>
                </div>
                <div class="detail">
                  {{detailData.warning_content}}
                </div>
              </div>
            </div>
          </div>
          <div class="infoBox">
            <div v-if="detailData.type == 0 || detailData.type == 3" class="details" :class="{noContent: isNoContent}" v-html="content" id="content"></div>
            <div v-else class="details editable">{{content}}</div>
            <div class="count" v-if="detailData.type == 1 || detailData.type == 4">
              <label>正文：</label><span>{{bodyText.length}}字 {{Math.ceil(bodyDurantion)}}秒</span>
              <label>导语：</label><span>{{headText.length}}字 {{Math.ceil(headDurantion)}}秒</span>
              <label>语速：</label><span>{{speed}}字/分钟</span>
            </div>
            <div class="column">
              <ul>
                <li><label>记者</label>
                  <a href="#" @click.prevent="">{{detailData.reporters}}</a>
                  <span v-if="!detailData.reporters" class="no">无</span>
                </li>
                <li><label>摄像</label>
                  <a href="#" @click.prevent="">{{detailData.cameras}}</a>
                  <span v-if="!detailData.cameras" class="no">无</span>
                </li>
                <li v-if="!!detailData.topicExist">
                  <label>{{`所属${$_syscfg.topic}`}}</label>
                  <!-- <router-link :to="`/topicDetail?d=${detailData.st_id}`">{{detailData.st_title}}</router-link> -->
                  <a href="#" @click.prevent="goTopic()">{{detailData.st_title}}</a>
                  <span v-if="!detailData.st_title" class="no">无</span>
                </li>
                <li v-if="!!detailData.interviewExist">
                  <label>{{`来源${$_syscfg.interview}`}}</label>
                  <!-- <router-link :to="`/interviewDetail?r=${detailData.iview_id}`">{{detailData.iview_title}}</router-link> -->
                  <a href="#" @click.prevent="goItv()">{{detailData.iview_title}}</a>
                  <span v-if="!detailData.iview_title" class="no">无</span>
                </li>
                <li v-if="detailData"><label>标签</label>
                  <small @click="goSelf(item)" v-for="(item, index) in detailData.tags" :key="index">{{item}}</small>
                  <span v-if="!detailData.tags || detailData.tags.length === 0" class="no">无</span>
                </li>
                <li><label>原文链接</label>
                  {{detailData.origin_link}}
                  <span v-if="!detailData.origin_link" class="no">无</span>
                </li>
                <li><label>备注</label>
                  {{detailData.remark}}
                  <span v-if="!detailData.remark" class="no">无</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="extendInfo" v-show="showExtendInfo">
            <div class="title">
              扩展信息
            </div>
            <div class="line noBottom">
              <div class="part">
                <span class="partTitle">
                  发生地点
                </span>
                <span class="partContent">
                  {{detailData.happen_address}}
                </span>
              </div>
              <div class="part">
                <span class="partTitle">
                  发生时间
                </span>
                <span class="partContent">
                  {{detailData.happen_time}}
                </span>
              </div>
            </div>
            <div class="line noBottom">
              <div class="part">
                <span class="partTitle">
                  发布时间
                </span>
                <span class="partContent">
                  {{detailData.release_time}}
                </span>
              </div>
              <div class="part">
                <span class="partTitle">
                  抓取时间
                </span>
                <span class="partContent">
                  {{detailData.grab_time}}
                </span>
              </div>
            </div>
            <div class="line noBottom">
              <div class="part">
                <span class="partTitle">
                  保密等级
                </span>
                <span class="partContent">
                  {{detailData.secret_level}}
                </span>
              </div>
              <div class="part">
                <span class="partTitle">
                  收录时间
                </span>
                <span class="partContent">
                  {{detailData.included_time}}
                </span>
              </div>
            </div>
            <div class="line noBottom">
              <div class="part">
                <span class="partTitle">
                  简介
                </span>
                <span class="partContent">
                  {{detailData.info}}
                </span>
              </div>
            </div>
          </div>
          <div class="exender" @click="toggleExtendor()">
            <span>
              {{showExtendInfo?'收起扩展信息':'查看扩展信息'}}
            </span>
            <img :src="showExtendInfo?icons.upGreen:icons.downGreen" alt="icons">
          </div>
        </article>
        <aside class="_xnsAside" v-show="!history_id">
          <div class="aside-content">
            <div class="nav">
              <ul>
                <li :class="{active:navOn==0}" @click="navSwitch(0)">图片 <span>{{detailData.img_list && detailData.img_list.length}}</span></li>
                <li :class="{active:navOn==1}" @click="navSwitch(1)">视频 <span>{{detailData.video_list && detailData.video_list.length}}</span></li>
                <li :class="{active:navOn==2}" @click="navSwitch(2)">音频 <span>{{detailData.sound_list && detailData.sound_list.length}}</span></li>
                <!-- <li :class="{active:navOn==3}" @click="navSwitch(3)">文件 <span>{{detailData.file_list && detailData.file_list.length}}</span></li> -->
              </ul>
            </div>
            <div class="nav-content">
              <div class="nav-item" v-if="navOn==0">
                <empty :msg="'暂无图片'" v-if="detailData.img_list && detailData.img_list.length === 0" />
                <div class="item" v-for="(img, index) in detailData.img_list" :key="index">
                  <div class="info">
                    <ul class="bottom">
                      <li>
                        <p>格式</p>
                        <span>{{img.content.type}}</span>
                      </li>
                      <li>
                        <p>大小</p>
                        <span>{{img.content.size}}</span>
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <p>尺寸</p>
                        <span>{{img.content.pixel}}</span>
                      </li>
                    </ul>
                  </div>
                  <ul>
                    <li class="thum" @mouseenter='zoomIn' @mouseleave='zoomOut' @click="goViewer(detailData, img)">
                      <img :src="img.cover || defaultImg" alt="cover" class="cover">
                      <div class="mask">查看更多</div>
                    </li>
                    <li class="title">
                      <h4>{{img.title}}</h4>
                    </li>
                    <li v-if="showDownload && img.original_exists" class="down">
                      <span @click="downloadSource(img)">
                      </span>
                    </li>
                  </ul>
                  <div v-if="quickEdit" class="btn add-qk append" @click="addQKFile(img, 'img')">
                    <button class="text add-qk">选用</button>
                  </div>
                </div>
              </div>
              <div class="nav-item" v-if="navOn==1">
                <empty :msg="'暂无视频'" v-if="detailData.video_list && detailData.video_list.length === 0" />
                <div class="item" v-for="(img, index) in detailData.video_list" :key="index">
                  <div class="info">
                    <ul class="bottom">
                      <li>
                        <p>格式</p>
                        <span>{{img.content.format}}</span>
                      </li>
                      <li>
                        <p>时长</p>
                        <span>{{img.content.duration}}</span>
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <p>大小</p>
                        <span>{{img.content.file_size}}</span>
                      </li>
                      <li>
                        <p>尺寸</p>
                        <span>{{img.content.resolution}}</span>
                      </li>
                    </ul>
                  </div>
                  <ul>
                    <li class="thum" @mouseenter='zoomIn' @mouseleave='zoomOut' @click="goViewer(detailData, img)">
                      <div class='verify-success verify-item' v-if="img.has_audit&&img.has_audit==1">
                        <img alt="技审通过" title="技审通过" class="verify-logo" src="@assets/img/common/verify-success-logo.svg">
                      </div>

                      <div class='verify-fail verify-item' v-if="img.has_audit&&img.has_audit==2">
                        <img alt="技审未通过" title="技审未通过" class="verify-logo" src="@assets/img/common/verify-fail-logo.svg">
                      </div>
                      <img :src="img.cover || defaultMedia" alt="cover" class="cover">
                      <img src="@assets/img/common/play.svg" alt="play" class="play">
                      <div class="mask">查看更多</div>
                    </li>
                    <li class="title">
                      <h4>{{img.title}}</h4>
                    </li>
                    <li class="down" v-if="showDownload">
                      <span @click="toggleD(img,$event)">
                        <div class="dOptions" v-show="img.showD">
                          <p :class="{'disableD': !detailData.has_low_quality_download_role || img.content.status != 1}" @click="downloadSource(img, 0)">
                            <img src="@assets/img/common/800k.svg" alt="800k">
                            <i>800K码流</i>
                          </p>
                          <p v-if="img.original_exists" :class="{'disableD': !detailData.has_high_quality_download_role}" @click="downloadSource(img, 1)">
                            <img src="@assets/img/common/HD.svg" alt="HD">
                            <i>原始码流</i>
                          </p>
                        </div>
                      </span>
                    </li>
                  </ul>
                  <div class="btn">
                    <button v-if="quickEdit" class="text half add-qk" @click="addQKFile(img, 'video')">选用</button>
                    <div class="text" :class="{half:quickEdit}" @click="goInPicture(img)">
                      进入画中画
                    </div>
                  </div>
                </div>
              </div>
              <div class="nav-item" v-if="navOn==2">
                <empty :msg="'暂无音频'" v-if="detailData.sound_list && detailData.sound_list.length === 0" />
                <div class="item" v-for="(img, index) in detailData.sound_list" :key="index">
                  <div class="info">
                    <ul class="bottom">
                      <li>
                        <p>格式</p>
                        <span>{{img.content.format}}</span>
                      </li>
                      <li>
                        <p>时长</p>
                        <span>{{img.content.duration}}</span>
                      </li>
                    </ul>
                    <ul>
                      <li>
                        <p>大小</p>
                        <span>{{img.content.file_size}}</span>
                      </li>
                      <li>
                        <p>声道</p>
                        <span>{{img.content.track}}</span>
                      </li>
                    </ul>
                  </div>
                  <ul>
                    <li class="thum" @mouseenter='zoomIn' @mouseleave='zoomOut' @click="goViewer(detailData, img)">
                      <img class="cover" :src="img['content']?(img['content'].cover || defaultMedia):defaultMedia" alt="cover">
                      <div class="mask">查看更多</div>
                    </li>
                    <li class="title">
                      <h4>{{img.title}}</h4>
                    </li>
                    <li class="down" v-if="showDownload && img.original_exists">
                      <span @click="downloadSource(img, 1)"></span>
                      <!-- <span @click="toggleD(img,$event)">
                        <div class="dOptions" v-show="img.showD">
                          <p :class="{'disableD': !detailData.has_low_quality_download_role || img.content.status != 1}" @click="downloadSource(img, 0)">
                            <img src="@assets/img/common/800k.svg" alt="800k">
                            <i>800K码流</i>
                          </p>
                          <p :class="{'disableD': !detailData.has_high_quality_download_role}" @click="downloadSource(img, 1)">
                            <img src="@assets/img/common/HD.svg" alt="HD">
                            <i>原始码流</i>
                          </p>
                        </div>
                      </span> -->
                    </li>
                  </ul>
                  <div v-if="quickEdit" class="btn add-qk append" @click="addQKFile(img, 'audio')">
                    <button class="text add-qk">选用</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
      <footer v-if="!history_id">
        <li class="button center">
          <div v-click-outside="hidePushsBtn" v-if="detailData.has_report_edit_role || detailData.has_publish || detailData.has_new_media" class="pushsBtn">
            <p @click="showPushsBtn = !showPushsBtn">
              推送
              <i :class="{on: showPushsBtn}"></i>
            </p>
            <div v-if="showPushsBtn" class="btn">
              <ul>
                <li v-if="detailData.has_report_edit_role && !!detailData.reportExist" @click="goReport()">{{`推送${$_syscfg.report}`}}</li>
                <li v-if="detailData.has_publish" @click="pushPublish(detailData.id, 'material')">{{`推送${$_syscfg.publish}`}}</li>
                <li v-if="detailData.has_new_media" @click="pushMedia(detailData)">推新发布</li>
              </ul>
              <span></span>
            </div>
          </div>
          <div v-click-outside="hideThreeBtn" v-if="detailData.has_download_role || detailData.has_stream_send" class="threeBtn">
            <p title="更多" @click="showThreeBtn = !showThreeBtn" :class="{on: showThreeBtn}"></p>
            <div v-if="showThreeBtn" class="btn">
              <ul>
                <li v-if="detailData.has_download_role" @click="download()">下载文稿</li>
                <li v-if="detailData.has_stream_send" @click="mediaSend(detailData.id)">归档</li>
              </ul>
              <span></span>
            </div>
          </div>
          <!-- <button v-if="detailData.has_report_edit_role && !!detailData.reportExist" @click="goReport()">{{`推送${$_syscfg.report}`}}</button>
          <button v-if="detailData.has_publish" @click="pushPublish(detailData.id, 'material')">{{`推送${$_syscfg.publish}`}}</button>
          <button style="background: none;border: 1px solid #41b48c;color: #41b48c" v-if="detailData.has_new_media" @click="pushMedia(detailData)">推新发布</button> -->
          <!-- <button v-if="detailData.has_download_role" @click="download()">下载文稿</button> -->
        </li>
        <div class="right button">
          <button class="yellow" @click="showWarning()">{{`${detailData.warning_content?'编辑':'添加'}警示`}}</button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import headline from "@components/headline";
import empty from "@components/empty";
import vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: { headline, empty },
  data() {
    return {
      visit_log: 0,
      visit_log_list: [],
      isXnew: this.$store.state.isXnew,
      headLines: {
        title: "",
        showLink: false,
        filter: false
      },
      icons: {
        upGreen: require("@assets/img/common/upward_green.svg"),
        downGreen: require("@assets/img/common/downward_green.svg")
      },
      defaultImg: require("@assets/img/common/default.png"),
      defaultMedia: require("@assets/img/common/defaultMedia.png"),
      defaultAudio: require("@assets/img/common/defaultAudio.png"),
      detailData: {},
      navOn: 0,
      isDialog: false,
      fileType: false,
      report_id: null,
      showVersions: false,
      history: [],
      history_id: "",
      speed: 0,
      bodyText: "", // 正文纯文字
      headText: "", // 导语纯文字
      bodyDurantion: 0, // 正文时长
      headDurantion: 0, // 导语时长
      showDownload: false,
      content: "",
      showExtendInfo: false,
      isNoContent: false,
      showView: false,
      showPushsBtn: false,
      showThreeBtn: false
    };
  },
  watch: {
    "$store.state.flashPic1": function (el) {
      if (el) {
        this.getData();
        this.$store.commit("setflashPic1", false);
      }
    },
    $route(to, from) {
      this.getPageVersion();
    }
  },
  computed: {
    quickEdit() {
      return this.$store.state.quickEdit;
    }
  },
  methods: {
    hidePushsBtn() {
      this.showPushsBtn = false;
    },
    hideThreeBtn() {
      this.showThreeBtn = false;
    },
    mediaSend(id) {
      this.showThreeBtn = false;
      let info = {
          subject_type: 0,
          subject_id: id
      };
      common
      .myFetch(apis.streamMediaSend, info)
      .then(r => {
          if (r) {
              this.$toast(r)
          }
      });
    },
    toggleView() {
      this.showView = !this.showView;
    },
    zoomIn(e) {
      let item = e.target;
      let children = item.children;
      let parent = item.parentNode.parentNode.children;
      let cover = '';
      let mask = '';
      for (let child of children) {
        if (child.classList.contains("cover")) {
          cover = child;
        }
      }

      for (let child of parent) {
        if (child.classList.contains("info")) {
          mask = child;
        }
      }

      cover.classList.add("zoom");
      mask.classList.add("show");
    },
    zoomOut(e) {
      let item = e.target;
      let children = item.children;
      let parent = item.parentNode.parentNode.children;
      let cover = '';
      let mask = '';
      for (let child of children) {
        if (child.classList.contains("cover")) {
          cover = child;
        }
      }

      for (let child of parent) {
        if (child.classList.contains("info")) {
          mask = child;
        }
      }

      cover.classList.remove("zoom");
      mask.classList.remove("show");
    },
    /**
     * 选用 为快编素材
     */
    addQKFile({ id }, type) {
      console.log("addQKFile  file id", id);
      console.log("addQKFile type", type);
      let data = {
        file_ids: id
      };
      common.myFetch(apis.File_addquickfile, data).then(res => {
        console.log("File_addquickfile res", res);
        if (res) {
          this.$toast("已成功加入选用素材");
        }
      });
    },
    async pushMedia(item) {
      console.log(item)
      this.showPushsBtn = false;
      const type = await this.$MediaPlatform('push');
      if (!type) return;
      console.log(type)
      let info = {
          platforms: type,
          submit_type: 0,
          subject_type: 0,
          subject_id: item.id
      };

      common
      .myFetch(apis.newMediaPlatformCreate, info)
      .then(r => {
          if (r) {
              console.log(r)
              common.jump(`/createMediaPublish?d=${r.report_id}`, true);
          }
      });
      // common.jump(`/createMediaPublish?d=${type}`, true);
    },
    async pushPublish(id, t) {
      // 推送发布
      this.showPushsBtn = false;
      const type = await this.$pageType("publish");
      if (!type) return;

      const info = {
        subject_id: id,
        subject_type: t,
        type: type
      };

      common.myFetch(apis.publish_pushPublish, info).then(r => {
        if (r) {
          const url = `/editPublish?d=${r.id}`;

          common.jump(url, true);
        }
      });
    },
    showWarning() {
      // 唤起警示窗口
      const content = {
        id: this.$route.query.d,
        type: 0,
        msg: this.detailData.warning_content
      };

      this.$warning(content).then(r => {
        if (r) {
          this.getData();
        }
      });
    },
    showCard(id, e) {
      if (id == 0) return;

      const el = e.target;

      this.$card(id, el);
    },
    showCard1(id, e) {
      if (id == 0) return;

      const el = e.target;

      console.log(e)

      this.$cardPos(id, e);
    },
    toggleExtendor() {
      this.showExtendInfo = !this.showExtendInfo;
    },
    goInPicture(item) {
      if (!item.content || item.content.status != 1) {
        this.$toast("转码中，暂时无法进入画中画");
        return;
      }

      this.$miniPicture(item.url);
    },
    hoverFailBtn(item, status) {
      // 转码失败按钮鼠标事件
      this.$set(item, "hover", status);
    },
    toggleD(i, e) {
      const el = e.target;
      let query = this.$route.query.d;
      this.$DownloadBtn(0, query, this.detailData, i, el);
      // this.$set(i, 'showD', !i.showD)
    },
    goTopic() {
      if (this.detailData.st_is_delete == 1 || !this.detailData.has_topic_role)
        return;

      this.$router.push({
        path: "/topicDetail",
        query: {
          d: this.detailData.st_id
        }
      });
    },
    goItv() {
      if (!this.detailData.has_interview_role) return;

      this.$router.push({
        path: "/interviewDetail",
        query: {
          r: this.detailData.iview_id
        }
      });
    },
    watchContent(c) {
      // 检测内容变化
      const bodyText = common.getBody(c);
      const headText = common.getLead(c);

      this.bodyText = common.replacePunctuations(bodyText);
      this.headText = common.replacePunctuations(headText);
      this.calculateText();
    },
    calculateText() {
      // 计算时长
      const gap = 60 / this.speed;
      this.bodyDurantion = gap * this.bodyText.length;
      this.headDurantion = gap * this.headText.length;
    },
    goSelf(i) {
      // 跳转自采线索并选中标签
      const cluetype = this.detailData.category - 0;
      let pageName = "";
      let internetType = "";
      switch (cluetype) {
        case 1:
          pageName = "internetClue";
          internetType = 1;
          break;

        case 2:
          pageName = "channelClue";
          break;

        case 3:
          pageName = "selfClue";
          break;

        case 4:
          pageName = "includedClue";
          break;

        case 5:
          pageName = "internetClue";
          internetType = 5;
          break;

        case 6:
          pageName = "internetClue";
          internetType = 6;
          break;

        default:
          pageName = "selfClue";
      }

      this.$router.push({
        name: pageName,
        params: {
          tag: i,
          internetType: internetType
        }
      });
    },
    async goViewer({ img_list, video_list, sound_list }, item) {
      if (!item.trans_finish) {
        this.$toast("转码中，暂时无法预览");
        return;
      }
      let config = {
        type: item.type,
        id: item.id,
        quickEdit: this.quickEdit,
        create: this.$store.state.create,
        canEdit: true,
        t: Number(0),
        d: this.$route.query.d,
        isDetailComplete: true
      };
      console.log("config", config);
      let list = [
        ...img_list,
        ...video_list.filter(e => e.content.status == 1),
        ...sound_list.filter(e => e.content.status == 1)
      ];
      // list 有id即可
      let index = list.findIndex(e => e.id == item.id);
      console.log("index", index);
      console.log("list", list);
      this.$materialBox(config, this.getData, {
        index,
        list,
        quickEdit: this.quickEdit,
        create: this.$store.state.create,
        canEdit: false,
        t: Number(0),
        d: this.$route.query.d,
        isDetailComplete: true
      });
    },
    goViewer1(data, item) {
      if (item.type != 1 && (!item.content || item.content.status != 1)) {
        this.$toast("转码中，暂时无法预览");
        return;
      }

      const now = {
        url: item.url,
        type: item.type - 0,
        downloadUrl: item.download_url
      };

      common.viewMedia(data, now);
    },
    getMedias() {
      // 获取内部媒体：图片／视频，并使用浏览器打开
      const content = document.getElementById("content");
      const imgs = content.getElementsByTagName("img");
      const videos = content.getElementsByTagName("video");
      const imglist = Array.from(imgs).map(i => i.src);

      for (let i of imgs) {
        i.addEventListener("click", () => {
          this.openViewer(imglist, i.src, "img");
        });
      }

      for (let v of videos) {
        v.addEventListener("click", () => {
          this.openViewer(
            videos,
            { url: i.src, downloadUrl: i.src, idstring: "" },
            "video"
          );
        });
      }
    },
    openViewer(list, src, type) {
      this.$viewer(list, src, type);
    },
    chooseVersion(i) {
      // 选择历史版本
      // const info = {
      //   history_id: i.history_id
      // }

      // common.myFetch(apis.clue_history, info)
      // .then(r => {
      //   if (r) {
      //     this.detailData = r.detail
      //     this.history_id = r.detail.history_id

      //     this.speed = this.detailData.content_speed || 0
      //     let content = this.detailData.content
      //     if (this.detailData.type == 0) {
      //       content = common.replaceN2Br(content)
      //     }
      //     this.content = content
      //     this.watchContent(this.detailData.content)

      //     this.$nextTick(() => {
      //       common.formatXNSAudios()
      //       common.handlePageMediaCenterPosition()
      //     })
      //   }
      // })

      this.showVersions = false;

      this.$router.push({
        path: "/clueDetail",
        query: {
          d: this.$route.query.d,
          h: i.history_id
        }
      });
    },
    toVersion(info) {
      // 取指定版本数据并渲染页面
      const emptyPage =
        '<img class="noContent" src="static/assets/img/emptyPage.svg" alt="empty">';

      common.myFetch(apis.clue_history, info).then(r => {
        if (r) {
          this.detailData = r.detail;
          this.history_id = r.detail.history_id;

          this.speed = this.detailData.content_speed || 0;
          let content = this.detailData.content;
          if (content == "") {
            this.isNoContent = true;
          }
          if (this.detailData.type == 0 || this.detailData.type == 3) {
            content = common.replaceN2Br(content);

            content = content || emptyPage;
          }
          this.content = content;
          this.watchContent(this.detailData.content);

          this.$nextTick(() => {
            common.formatXNSAudios();
            common.handlePageMediaCenterPosition();
            let video = document.querySelectorAll('#content video')
            for (let index = 0; index < video.length; index++) {
              video[index].style.display = 'flex'
              video[index].style.margin = '0 auto'
              video[index].style.maxWidth = '80%'
            }
            let img = document.querySelectorAll('#content img')
            for (let index = 0; index < img.length; index++) {
              img[index].style.display = 'flex'
              img[index].style.margin = '0 auto'
              img[index].style.maxWidth = '80%'
            }
            let audio = document.querySelectorAll('#content audio')
            for (let index = 0; index < audio.length; index++) {
              audio[index].style.display = 'flex'
              audio[index].style.margin = '0 auto'
              audio[index].style.maxWidth = '80%'
            }
            let iframe = document.querySelectorAll('#content iframe')
            for (let index = 0; index < iframe.length; index++) {
              iframe[index].style.display = 'flex'
              iframe[index].style.margin = '0 auto'
              iframe[index].style.maxWidth = '80%'
              iframe[index].style.boxShadow = '4px 4px 10px 0 rgba(5,10,15,0.05)'
            }
          });
        }
      });
    },
    toggleVersions() {
      this.showVersions = !this.showVersions;
    },
    // downloadSource(img) {
    //   window.open(img.url, true)
    // },
    downloadSource(source, type) {
      console.log(source)
      if (type === 0) {
        if (!this.detailData.has_low_quality_download_role) {
          this.$toast("无下载权限");
          return;
        } else {
          if (source.content.status != 1) {
            this.$toast("转码尚未完成");
            return;
          }
        }
      } else if (type === 1) {
        if(source.type == 3){
          if (!this.detailData.has_high_quality_download_role && !this.detailData.has_low_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }else{
          if (!this.detailData.has_high_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }
      }

      const info = {
        idstring: source.idstring,
        file_quality: type || 0,
        subject_type: 0,
        subject_id: this.$route.query.d
      };
      const url = apis.File_download;
      const userKeys = common.userKeys();
      const params = Object.assign({}, info, userKeys);

      common.exportRes(url, params, 1);
    },
    download() {
      this.showThreeBtn = false;
      const info = {
        id: this.$route.query.d
      };

      const userKeys = common.userKeys();
      const params = Object.assign({}, info, userKeys);
      const url = apis.download_clue;

      common.exportRes(url, params);
    },
    goWord(idstring, type) {
      let url = `/videotoword?d=${idstring}`;
      if (type === "audio") {
        url = `/audiotoword?d=${idstring}`;
      }

      common.jump(url, true);
    },
    convertWord(f) {
      // 音视频转文字
      if (!f.content || f.content.status != 1) {
        this.$toast("转码中，暂时无法转文字");
        return;
      }

      const info = {
        idstring: f.idstring
      };

      common.myFetch(apis.File_convert, info).then(r => {
        if (r) {
          this.$toast(r);

          this.$set(f, "text_status", 2);
        }
      });
    },
    async goReport() {
      this.showPushsBtn = false;
      const type = await this.$pageType();
      const id = this.$route.query.d;
      if (!type) return;

      const info = {
        id: id,
        type: type
      };
      const newWindow = window.open();

      common.myFetch(apis.clue_toReport, info).then(r => {
        if (r) {
          const reportId = r.report_id;

          newWindow.location.href = `${window.location.origin
            }/creatReport?push=${id}&t=${type}&d=${reportId}`;

          // common.jump(`/creatReport?push=${id}&t=${type}&d=${reportId}`, true)
        }
      });
    },
    navSwitch(n) {
      this.navOn = n;
      // this.getData()
    },
    dialog() {
      this.isDialog = !this.isDialog;
    },
    getData() {
      const id = this.$route.query.d;
      const info = {
        id: id
      };
      const emptyPage =
        '<img class="noContent" src="static/assets/img/emptyPage.svg" alt="empty">';

      common.myFetch(apis.clueDetail, info).then(res => {
        if (res) {
          this.detailData = res.detail;
          this.visit_log_list = res.detail.visit_log;
          this.visit_log = res.detail.visit_log.length;
          // 自动定位到第一项有内容的资源上
          if (this.detailData.img_list.length === 0) {
            if (this.detailData.video_list.length === 0) {
              if (this.detailData.sound_list.length !== 0) {
                this.navSwitch(2);
              }
            } else {
              this.navSwitch(1);
            }
          }

          this.showDownload =
            this.detailData.has_high_quality_download_role ||
            this.detailData.has_low_quality_download_role;
          this.speed = this.detailData.content_speed || 0;
          let content = this.detailData.content;
          if (content == "") {
            this.isNoContent = true;
          }
          if (this.detailData.type == 0 || this.detailData.type == 3) {
            content = common.replaceN2Br(content);
            // content = common.replaceBlank2NBSP(content)
            content = content || emptyPage;
          }
          this.content = content;
          this.watchContent(this.detailData.content);

          this.$nextTick(() => {
            common.formatXNSAudios();
            common.handlePageMediaCenterPosition();
            let video = document.querySelectorAll('#content video')
            for (let index = 0; index < video.length; index++) {
              video[index].style.display = 'flex'
              video[index].style.margin = '0 auto'
              video[index].style.maxWidth = '80%'
            }
            let img = document.querySelectorAll('#content img')
            for (let index = 0; index < img.length; index++) {
              img[index].style.display = 'flex'
              img[index].style.margin = '0 auto'
              img[index].style.maxWidth = '80%'
            }
            let audio = document.querySelectorAll('#content audio')
            for (let index = 0; index < audio.length; index++) {
              audio[index].style.display = 'flex'
              audio[index].style.margin = '0 auto'
              audio[index].style.maxWidth = '80%'
            }
            let iframe = document.querySelectorAll('#content iframe')
            for (let index = 0; index < iframe.length; index++) {
              iframe[index].style.display = 'flex'
              iframe[index].style.margin = '0 auto'
              iframe[index].style.maxWidth = '80%'
              iframe[index].style.boxShadow = '4px 4px 10px 0 rgba(5,10,15,0.05)'
            }
          });
        }
      });
    },
    getVersions() {
      // 获取历史版本号
      const id = this.$route.query.d;
      const info = {
        id: id
      };

      common.myFetch(apis.clue_versions, info).then(r => {
        if (r) {
          this.history = r.list;
        }
      });
    },
    getTranstext(r) {
      // 获取转文字状态
      this.$toast("转文字完成");
      this.getData();
    },
    getTranscode(r) {
      // 获取转码通知
      const info = r.content;
      if (info) {
        this.$toast(`${info.title}已入库`);
        this.getData();
      }
    },
    getPageVersion() {
      // 根据url参数选择渲染当前或历史版本
      const h = this.$route.query.h;
      if (h) {
        const info = {
          history_id: h
        };

        this.toVersion(info);
      } else {
        this.history_id = null;

        this.getData();
      }
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    this.defaultMedia = this.$_syscfg.default_media
    // this.getData()
    this.headLines.title = `${this.$_syscfg.clue}详情`;
    this.getPageVersion();
    this.getVersions();
    common.handleSocket(this.getTranstext, "pickuptext");
    common.handleSocket(this.getTranscode, "transcode");
  },
};
</script>

<style src="@assets/css/mediaDetails/mediaDetails.less" lang="less" scoped>
</style>
<style lang="less" scoped>
.imgContainer {
  .relative {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
<style lang="less">
.clueD-container {
  .imgContainer {
    .relative {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
.infoBox {
  .details {
    p {
      word-break: normal !important;
      word-wrap:break-word !important;
    }
  }
}
</style>